import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Icon from "../../components/Icon";
import Button from "../../components/Button";
import EmailWidthPicker from "../../components/EmailWidthPicker";
import {
  Toolbar,
  ToolbarGroup,
  ToolbarFlexibleSpacer,
} from "../../components/Toolbar";
import {
  setEditorDisplayWidth,
  toggleEditorBreakdown,
  updateEmail,
  openModal,
  updateEditorTranslationVariation,
} from "../../actions";
import { history } from "../../history";

export class QAEmailToolbar extends Component {
  constructor(props) {
    super(props);
    this.setPreviewWidth = this.setPreviewWidth.bind(this);
    this.save = this.save.bind(this);
    this.openSendModal = this.openSendModal.bind(this);
    this.close = this.close.bind(this);
  }

  close() {
    const { accountId, email } = this.props;
    const parentUrl = `/clients/${accountId}/campaigns/${email.campaignId}/emails/${email.id}`;
    history.push(parentUrl);
  }

  openSendModal() {
    const { accountId } = this.props;
    const { id } = this.props.email;
    this.props.openModal("send-email", {
      accountId,
      id,
    });
  }

  setPreviewWidth(width) {
    this.props.setEditorDisplayWidth(width);
  }

  save() {
    const { accountId } = this.props;
    if (this.props.email.id) {
      this.props.updateEmail(accountId, this.props.email.id, this.props.email);
    } else {
      console.log("CREATE NEW");
    }
  }

  render() {
    const { email, unsavedChanges, breakdown, displayWidth, accountId } =
      this.props;

    if (!email) {
      return <Toolbar />;
    }

    const { translations } = email;

    const updateTranslationVariation = (e) => {
      this.props.updateEditorTranslationVariation(e.currentTarget.value);
    };

    const translationPicker = translations ? (
      <select onChange={updateTranslationVariation} value={email.var || Object.keys(translations)[0]}>
        {Object.keys(translations).map((key) => {
          return (
            <option key={key} value={key}>
              {key}
            </option>
          );
        })}
      </select>
    ) : undefined;

    return (
      <Toolbar>
        <ToolbarGroup width="400px">
          {email.name}
          &nbsp;
          {translationPicker}
        </ToolbarGroup>

        <ToolbarFlexibleSpacer />

        <ToolbarGroup width="290" minWidth="290">
          <EmailWidthPicker
            width={displayWidth}
            onChange={this.setPreviewWidth}
          />
        </ToolbarGroup>

        <ToolbarFlexibleSpacer />

        <ToolbarGroup width="400px" align="right">
          <Button title="Close" type="link" onClick={this.close}>
            <Icon icon="close" />
          </Button>
          <Button title="Send" type="link" onClick={this.openSendModal}>
            <Icon icon="envelope" />
          </Button>
        </ToolbarGroup>
      </Toolbar>
    );
  }
}

QAEmailToolbar.propTypes = {
  setEditorDisplayWidth: PropTypes.func.isRequired,
  toggleEditorBreakdown: PropTypes.func.isRequired,
  updateEmail: PropTypes.func.isRequired,
  email: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  unsavedChanges: PropTypes.bool.isRequired,
  breakdown: PropTypes.bool.isRequired,
  displayWidth: PropTypes.number.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const { email, unsavedChanges, breakdown, displayWidth } = state.editor;
  return {
    email,
    displayWidth,
    unsavedChanges,
    breakdown,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  setEditorDisplayWidth,
  toggleEditorBreakdown,
  updateEmail,
  openModal,
  updateEditorTranslationVariation,
})(QAEmailToolbar);
